import { render, staticRenderFns } from "./TimelineActionBarAnnotation.vue?vue&type=template&id=6b21aa9a&"
import script from "./TimelineActionBarAnnotation.vue?vue&type=script&lang=js&"
export * from "./TimelineActionBarAnnotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports